import * as ActionTypes from "./actionTypes";
import * as Actions from "./action";
import { AccountPayablesError, AccountPayablesErrorOrigin } from "./types";
import { ErrorAction } from "src/common/apiLoader/state/actions";
import { parseDataKey } from "src/common/util";
import { ExpenditureRecord } from "src/common/models/expenditureRecord";
import { PayableContractDebit } from "src/common/models/payableContractDebit";
import { PayableContractPayment } from "src/common/models/payableContractDebitPayment";

export interface AccountPayablesState {
    error?: AccountPayablesError
    expenditureRecords?: ExpenditureRecord[]
    createExpenditureRecordSuccess: boolean
    payableContractDebits?: PayableContractDebit[]
    currentPayableDebit?: PayableContractDebit
    createPayablePaymentSuccess: boolean
    contractPayments?: PayableContractPayment[]
    deletePayableContractDebitSuccess: boolean
}

const initialState: AccountPayablesState = {
    createExpenditureRecordSuccess: false,
    createPayablePaymentSuccess: false,
    deletePayableContractDebitSuccess: false,
}

const accountPayablesReducer = (state: AccountPayablesState = initialState, action: any): AccountPayablesState => {
    switch (action.type) {
        case ActionTypes.GET_EXPENDITURE_RECORDS_API: {
            return {
                ...state,
                expenditureRecords: undefined,
            }
        }
        case ActionTypes.GET_EXPENDITURE_RECORDS_API_SUCCESS: {
            const successAction = action as Actions.GetExpenditureRecordsSuccessAction

            return {
                ...state,
                expenditureRecords: parseDataKey(successAction.expenditureRecords),
            }
        }
        case ActionTypes.GET_EXPENDITURE_RECORDS_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: AccountPayablesErrorOrigin.GET_EXPENDITURE_RECORDS,
                    detail: errorAction.error,
                }
            }
        }
        case ActionTypes.CREATE_EXPENDITURE_RECORD_API: {
            return {
                ...state,
                error: undefined,
                createExpenditureRecordSuccess: false,
            }
        }
        case ActionTypes.CREATE_EXPENDITURE_RECORD_API_SUCCESS: {
            return {
                ...state,
                createExpenditureRecordSuccess: true,
            }
        }
        case ActionTypes.CREATE_EXPENDITURE_RECORD_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: AccountPayablesErrorOrigin.CREATE_EXPENDITURE_RECORD,
                    detail: errorAction.error,
                }
            }
        }
        case ActionTypes.GET_PAYABLE_CONTRACT_DEBITS_API: {
            return {
                ...state,
                error: undefined,
                payableContractDebits: undefined,
            }
        }
        case ActionTypes.GET_PAYABLE_CONTRACT_DEBITS_API_SUCCESS: {
            const successAction = action as Actions.GetPayableContractDebitsSuccessAction

            return {
                ...state,
                payableContractDebits: parseDataKey(successAction.payableContractDebits),
            }
        }
        case ActionTypes.GET_PAYABLE_CONTRACT_DEBITS_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: AccountPayablesErrorOrigin.GET_PAYABLE_CONTRACT_DEBITS,
                    detail: errorAction.error,
                }
            }
        }
        case ActionTypes.GET_PAYABLE_DEBIT_BY_ID_API: {
            return {
                ...state,
                error: undefined,
                currentPayableDebit: undefined,
            }
        }
        case ActionTypes.GET_PAYABLE_DEBIT_BY_ID_API_SUCCESS: {
            const successAction = action as Actions.GetPayableDebitByIdSuccessAction

            return {
                ...state,
                currentPayableDebit: successAction.payableDebit,
            }
        }
        case ActionTypes.GET_PAYABLE_DEBIT_BY_ID_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: AccountPayablesErrorOrigin.GET_PAYABLE_DEBIT_BY_ID,
                    detail: errorAction.error,
                }
            }
        }
        case ActionTypes.CLEAN_CURRENT_PAYABLE_DEBIT: {
            return {
                ...state,
                currentPayableDebit: undefined,
            }
        }
        case ActionTypes.CREATE_PAYABLE_DEBIT_PAYMENT_API: {
            return {
                ...state,
                error: undefined,
                createPayablePaymentSuccess: false,
            }
        }
        case ActionTypes.CREATE_PAYABLE_DEBIT_PAYMENT_API_SUCCESS: {
            return {
                ...state,
                createPayablePaymentSuccess: true,
            }
        }
        case ActionTypes.CREATE_PAYABLE_DEBIT_PAYMENT_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: AccountPayablesErrorOrigin.CREATE_PAYABLE_PAYMENT,
                    detail: errorAction.error,
                }
            }
        }
        case ActionTypes.GET_PAYABLE_CONTRACT_PAYMENTS_API: {
            return {
                ...state,
                contractPayments: undefined,
                error: undefined,
            }
        }
        case ActionTypes.GET_PAYABLE_CONTRACT_PAYMENTS_API_SUCCESS: {
            const successAction = action as Actions.GetPayableContractPaymentRecordsSuccessAction

            return {
                ...state,
                contractPayments: parseDataKey(successAction.contractPayments),
            }
        }
        case ActionTypes.GET_PAYABLE_CONTRACT_PAYMENTS_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: AccountPayablesErrorOrigin.GET_PAYABLE_CONTRACT_PAYMENTS,
                    detail: errorAction.error,
                }
            }
        }
        case ActionTypes.DELETE_PAYABLE_CONTRACT_DEBIT_API: {
            return {
                ...state,
                deletePayableContractDebitSuccess: false,
                error: undefined,
            }
        }
        case ActionTypes.DELETE_PAYABLE_CONTRACT_DEBIT_API_SUCCESS: {
            return {
                ...state,
                deletePayableContractDebitSuccess: true,
            }
        }
        case ActionTypes.DELETE_PAYABLE_CONTRACT_DEBIT_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: AccountPayablesErrorOrigin.DELETE_PAYABLE_CONTRACT_DEBIT,
                    detail: errorAction.error,
                }
            }
        }
    }
    return state;
};


export default accountPayablesReducer;